import { getLicenseList, saveLicense, updateLicense, deleteLicense } from '../services';
import { getCommodityList } from '@/routes/Apply/services';

export default {
  namespace: 'thirdLicense',
  state: {

  },
  effects: {
    * getLicenseList ({ payload }, { call }) {
      const result = yield call(getLicenseList, payload);
      return result;
    },

    * saveLicense ({ payload }, { call }) {
      const result = yield call(saveLicense, payload);
      return result;
    },

    * updateLicense ({ payload }, { call }) {
      const result = yield call(updateLicense, payload);
      return result;
    },

    * deleteLicense ({ payload }, { call }) {
      const result = yield call(deleteLicense, payload);
      return result;
    },

    * getCommodityList ({ payload }, { call }) {
      const result = yield call(getCommodityList, payload);
      return result;
    }
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};